// extracted by mini-css-extract-plugin
module.exports = {"on3Primary":"#fe3b1f","block":"SignUpFooter_block__7K9HT","container":"SignUpFooter_container__gXpkR","message":"SignUpFooter_message__deNIV","terms":"SignUpFooter_terms__AP9cv"};